// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","red":"#e40000","grey":"#707070","white":"#ffffff","sidebar-width":"266px","airtelLogo":"_1tFgoTGL9fuMKvzAWN6ytj","sidebar":"_245rVexpq8OFnll-Av24yh","sidebarContainer":"_2qPsRp_e3TFBjPgwrBWFDu","sidebarPadding":"_2nGnuPTHuiqvfBcT0vc3P1","linksList":"_2AVvK3z2mmXeMp8Jtzd9PK","iconSection":"_8YwmxYitRqCA73Akz4nvh","docsLinkList":"_1RRGKyZ86i0KKI4gHm8aki"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/sidebar.css
// module id = 1594
// module chunks = 0